// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/models/referrals.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "core.bridge";

export interface Referral {
  /** stores a 16-bit unsigned integer */
  id: number;
  withdrawalAddress: string;
  commissionRate: string;
}

export interface ReferralRewards {
  referralId: number;
  tokenId: string;
  toClaim: string;
  totalClaimedAmount: string;
}

function createBaseReferral(): Referral {
  return { id: 0, withdrawalAddress: "", commissionRate: "" };
}

export const Referral: MessageFns<Referral> = {
  encode(message: Referral, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.withdrawalAddress !== "") {
      writer.uint32(18).string(message.withdrawalAddress);
    }
    if (message.commissionRate !== "") {
      writer.uint32(26).string(message.commissionRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Referral {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferral();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.withdrawalAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commissionRate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Referral {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      withdrawalAddress: isSet(object.withdrawalAddress)
        ? globalThis.String(object.withdrawalAddress)
        : isSet(object.withdrawal_address)
        ? globalThis.String(object.withdrawal_address)
        : "",
      commissionRate: isSet(object.commissionRate)
        ? globalThis.String(object.commissionRate)
        : isSet(object.commission_rate)
        ? globalThis.String(object.commission_rate)
        : "",
    };
  },

  toJSON(message: Referral): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.withdrawalAddress !== "") {
      obj.withdrawalAddress = message.withdrawalAddress;
    }
    if (message.commissionRate !== "") {
      obj.commissionRate = message.commissionRate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Referral>, I>>(base?: I): Referral {
    return Referral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Referral>, I>>(object: I): Referral {
    const message = createBaseReferral();
    message.id = object.id ?? 0;
    message.withdrawalAddress = object.withdrawalAddress ?? "";
    message.commissionRate = object.commissionRate ?? "";
    return message;
  },
};

function createBaseReferralRewards(): ReferralRewards {
  return { referralId: 0, tokenId: "0", toClaim: "", totalClaimedAmount: "" };
}

export const ReferralRewards: MessageFns<ReferralRewards> = {
  encode(message: ReferralRewards, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.referralId !== 0) {
      writer.uint32(8).uint32(message.referralId);
    }
    if (message.tokenId !== "0") {
      writer.uint32(16).uint64(message.tokenId);
    }
    if (message.toClaim !== "") {
      writer.uint32(26).string(message.toClaim);
    }
    if (message.totalClaimedAmount !== "") {
      writer.uint32(34).string(message.totalClaimedAmount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReferralRewards {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferralRewards();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.referralId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.toClaim = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.totalClaimedAmount = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReferralRewards {
    return {
      referralId: isSet(object.referralId)
        ? globalThis.Number(object.referralId)
        : isSet(object.referral_id)
        ? globalThis.Number(object.referral_id)
        : 0,
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
      toClaim: isSet(object.toClaim)
        ? globalThis.String(object.toClaim)
        : isSet(object.to_claim)
        ? globalThis.String(object.to_claim)
        : "",
      totalClaimedAmount: isSet(object.totalClaimedAmount)
        ? globalThis.String(object.totalClaimedAmount)
        : isSet(object.total_claimed_amount)
        ? globalThis.String(object.total_claimed_amount)
        : "",
    };
  },

  toJSON(message: ReferralRewards): unknown {
    const obj: any = {};
    if (message.referralId !== 0) {
      obj.referralId = Math.round(message.referralId);
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    if (message.toClaim !== "") {
      obj.toClaim = message.toClaim;
    }
    if (message.totalClaimedAmount !== "") {
      obj.totalClaimedAmount = message.totalClaimedAmount;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReferralRewards>, I>>(base?: I): ReferralRewards {
    return ReferralRewards.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReferralRewards>, I>>(object: I): ReferralRewards {
    const message = createBaseReferralRewards();
    message.referralId = object.referralId ?? 0;
    message.tokenId = object.tokenId ?? "0";
    message.toClaim = object.toClaim ?? "";
    message.totalClaimedAmount = object.totalClaimedAmount ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
